import { HttpClient, HttpHeaders, HttpParameterCodec, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, Occ, OccEndpointsService } from '@spartacus/core'
import { CART_NORMALIZER } from '@spartacus/cart/base/root'
import { OccCartAdapter } from '@spartacus/cart/base/occ'

class HttpParamEncoder implements HttpParameterCodec {
  encodeKey (key: string) {
    return encodeURIComponent(key)
  }

  encodeValue (value: string) {
    return encodeURIComponent(value)
  }

  decodeKey (key: string) {
    return decodeURIComponent(key)
  }

  decodeValue (value: string) {
    return decodeURIComponent(value)
  }
}

@Injectable({
  providedIn: 'root'
})
export class MbOccSaveCartAdapter extends OccCartAdapter {

  constructor (protected http: HttpClient,
               protected occEndpointsService: OccEndpointsService,
               protected converterService: ConverterService) {
    super(http, occEndpointsService, converterService)
  }

  save (userId: string,
        cartId: string,
        saveCartName?: string,
        saveCartDescription?: string) {
    let httpParams = new HttpParams({ encoder: new HttpParamEncoder() })
    if (saveCartName) {
      httpParams = httpParams.set('saveCartName', saveCartName)
    }
    if (saveCartDescription) {
      httpParams = httpParams.set('saveCartDescription', saveCartDescription)
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })
    return this.http.patch<Occ.Cart>(this.occEndpointsService.buildUrl('saveCart', {
        urlParams: {
          userId,
          cartId
        }
      }),
      httpParams,
      { headers }
    ).pipe(this.converterService.pipeable(CART_NORMALIZER))
  }
}
